/*!
    * @product/scmp-sdk 1.1.39-hotfix.1
    * built by undefined
  */
function n(){if(!(typeof window>"u"))return window}export{n as a};
//# sourceMappingURL=chunk-KSSDEKP4.js.map
